import CreditCard from "./CreditCard";
import Doc from "./Doc";
import Check from "./Check";

export { CreditCard, Doc, Check };

export default { CreditCard, Doc, Check };
